import keyboard from '../utils/keyboard';

const $ = jQuery;
const $toggle = $( '[data-toggle="tabs"]' );

const getPanelFromToggle = $toggleBtn => {
	return $( `#${ $toggleBtn.attr( 'aria-controls' ) }` );
};

const toggle = $toggleBtn => {
	const $parent = $toggleBtn.parents( '[data-tabs]' );

	if ( $parent.hasClass( 'animating' ) ) {
		return;
	}

	$parent.addClass( 'animating' );

	const $activeToggle = $parent.find( '[aria-selected="true"]' );
	const $activePanel = getPanelFromToggle( $activeToggle );

	const $nextToggle = $toggleBtn;
	const $nextPanel = getPanelFromToggle( $toggleBtn );

	$activePanel.removeClass( 'active' );

	$activeToggle
		.removeClass( 'active' )
		.attr( 'aria-selected', 'false' )
		.attr( 'tabindex', '-1' );

	$nextToggle
		.addClass( 'active' )
		.attr( 'aria-selected', 'true' )
		.attr( 'tabindex', '0' );

	$nextPanel
		.css( {
			display: 'block',
			height: 'auto'
		} )
		.animate( {
			opacity: 1
		}, 300, () => {
			$nextPanel
				.addClass( 'active' )
				.removeAttr( 'style' );

			$parent.removeClass( 'animating' );

			if ( ! $nextToggle.is( ':focus' ) ) {
				$nextToggle.focus();
			}
		} );
};

const focus = ( $toggleBtn, direction ) => {
	const $parent = $toggleBtn.parents( '[data-tabs]' );
	const $tabs = $parent.find( '.tab-toggle' );

	const maxIndex = $tabs.length - 1;
	let currentIndex = null;

	$tabs.each( ( i, el ) => {
		if ( $( el ).hasClass( 'active' ) ) {
			currentIndex = i;
		}
	} );

	let goToIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

	// Hit prev on first element, goto last
	goToIndex = goToIndex === -1 ? maxIndex : goToIndex;

	// Hit next on last element, goto first
	goToIndex = goToIndex > maxIndex ? 0 : goToIndex;

	const $nextTab = $tabs.eq( goToIndex );

	toggle( $nextTab );
};

const bind = () => {
	$toggle.on( 'click', e => {
		const $toggleBtn = $( e.currentTarget );
		toggle( $toggleBtn );
	} );

	// Tab focus from active tab to active panel
	$( '.tab-toggle' ).on( 'keydown', e => {
		if ( e.keyCode === keyboard.tab && ! e.shiftKey ) {
			e.preventDefault();
			$( e.currentTarget )
				.parents( '[data-tabs]' )
				.find( '.tabpanel.active' )
				.focus();
		}
	} );

	$( '.tab-toggle' ).on( 'keydown', e => {
		if ( e.keyCode === keyboard.right || e.keyCode === keyboard.left ) {
			e.preventDefault();
			const direction = e.keyCode === keyboard.right ? 'next' : 'prev';
			focus( $( e.currentTarget ), direction );
		}
	} );

	// Shift + Tab focus from active panel to active tab
	$( '.tabpanel' ).on( 'keydown', e => {
		if ( e.keyCode === keyboard.tab && e.shiftKey ) {
			e.preventDefault();
			$( e.currentTarget )
				.parents( '[data-tabs]' )
				.find( '.tab-toggle.active' )
				.focus();
		}
	} );
};

export default () => {
	if ( ! $toggle.length ) {
		return;
	}

	bind();
};
